import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastNotificationService } from './toast-notification.service';
import { ResetPasswordRequest } from './reset-password-request';
import { SetPasswordRequest } from './set-password-request';
import { Router } from '@angular/router';
import { Observable } from "rxjs";
import { LoginInfo } from "./LoginInfo";
import { ImpersonationService } from './impersonation-service';
export const TOKEN_NAME: string = 'jwt_token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loginEndpoint = environment.loginTokenUrl;
  adminApiEndpoint = environment.adminApiUrl;
  portalApiEndpoint = environment.portalApiUrl;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private helper = new JwtHelperService();
  private clientId = 'icp.ams.api';

  constructor(private http: HttpClient
    , private router: Router
      , private notificationService: ToastNotificationService
    , private impersonationService: ImpersonationService) {

  }
  authentication = {
    isAuthenticated: false,
    userName: '',
    useRefreshTokens: false
  };


  getToken(): string {
    return localStorage.getItem(TOKEN_NAME) as string;
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_NAME, token);
  }

  getTokenExpirationDate(token: string): Date | null {
    if (!token) token = this.getToken();
    const decoded = this.helper.decodeToken(token);

    if (decoded.exp === undefined) return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token: string | null = null): boolean {
    if (!token) token = this.getToken();
    if (!token) return true;

    return this.helper.isTokenExpired(token);
  }

  initiateResetPassword(ResetPasswordRequest: ResetPasswordRequest) {
    return this.http.post<any>(this.loginEndpoint + 'initiate_reset', ResetPasswordRequest)
      .toPromise()
  }

  setPassword(setPasswordRequest: SetPasswordRequest) {
    return this.http.post<any>(this.loginEndpoint + 'reset_password', setPasswordRequest)
      .toPromise()
  }

  login(loginData: any) {
    //var data = 'grant_type=password&username=' + this.urlFormEncode(loginData.username) + '&password=' + this.urlFormEncode(loginData.password);

    //data = data + '&client_id=' + this.clientId;

    return this.http.post(this.loginEndpoint + 'token', loginData)
      .toPromise()
  }

  getLoginInfo(): Observable<LoginInfo> {
    return this.http.get<LoginInfo>(this.loginEndpoint + 'login_info');
  }

  whoAmI() {
    return this.http.get(this.loginEndpoint + 'whoami')
      .toPromise()
      .then(function (data: any) {
        localStorage.setItem('userId', data.userId);
        localStorage.setItem('userFirstName', data.firstName);
        localStorage.setItem('userLastName', data.lastName);
      })
      .catch((err/*, status*/) => {
        console.log(err);
        this.notificationService.error('failed to get current user Identity');
        this.logout();
      });
  }
  urlFormEncode(value: any) {
    var result = encodeURIComponent(value);
    result.replace(/%20/g, '+');
    return result;
  }
  logout() {
    if (localStorage.getItem("impersonating")) {
        this.endImpersonation();
    }
    localStorage.clear();

    this.authentication.isAuthenticated = false;
    this.authentication.userName = '';
    this.authentication.useRefreshTokens = false;

    return this.router.navigate(['/admin-portal/login']);

  }
  publicLogout() {
    if (localStorage.getItem("impersonating")) {
        this.endImpersonation();
    }
    localStorage.clear();

    this.authentication.isAuthenticated = false;
    this.authentication.userName = '';
    this.authentication.useRefreshTokens = false;

    return this.router.navigate(['/public/member-directory']).then(() => window.location.reload());
    }

    endImpersonation(): void {
        this.impersonationService.endImpersonation().subscribe({
            next: (status) => {
                this.impersonationService.impersonationStatus.next(status);
            },
        });
    }

  canAccessMemberOnlyContent() {
    var memberLevel = localStorage.getItem('membershipLevel');
    switch (memberLevel) {
      case 'SuperAdmin':
      case 'Silver':
      case 'Gold':
      case 'Platinum':
      case 'Signature':
      case 'Private':
      case 'CommercialClub':
      case 'LeadershipCircle':
      case 'Startup':
        return true;
      case 'Prospect':
      case 'Denied':
      case 'FormerMember':
      case 'PendingApplication':
      case 'HealthAlliance':
        return false;
      default:
        return false;
    }
    }

    hasLetterOfIntroPerk() {
        var memberLevel = localStorage.getItem('membershipLevel');
        switch (memberLevel) {
            case 'Gold':
            case 'Platinum':
            case 'Signature':
            case 'Private':
            case 'CommercialClub':
            case 'LeadershipCircle':
                return true;
            case 'Startup':
            case 'SuperAdmin':
            case 'Prospect':
            case 'Denied':
            case 'FormerMember':
            case 'PendingApplication':
            case 'HealthAlliance':
            case 'Silver':
            default:
                return false;
        }
    }
    hasAdsPerk() {
        var memberLevel = localStorage.getItem('membershipLevel');
        switch (memberLevel) {
            case 'Platinum':
            case 'Signature':
            case 'Private':
            case 'CommercialClub':
            case 'LeadershipCircle':
                return true;
            case 'Gold':
            case 'SuperAdmin':
            case 'Prospect':
            case 'Denied':
            case 'FormerMember':
            case 'PendingApplication':
            case 'HealthAlliance':
            case 'Silver':
            case 'Startup':
            default:
                return false;
        }
    }

}
